export function clientSideOrderBy<T>(orderBy: keyof T, order: 'asc' | 'desc') {
  return (a: T, b: T) => {
    const aValue = a[orderBy]
    const bValue = b[orderBy]

    const isUndefined = (value: any): value is undefined => typeof value === 'undefined'
    const isBoolean = (value: any): value is boolean => typeof value === 'boolean'
    const isNumber = (value: any): value is number => typeof value === 'number'
    const isString = (value: any): value is string => typeof value === 'string'

    const undefinedFirst = order === 'asc' ? -1 : 1
    const undefinedLast = order === 'asc' ? 1 : -1

    if (isUndefined(aValue) && isUndefined(bValue)) return 0
    if (isUndefined(aValue)) return undefinedFirst
    if (isUndefined(bValue)) return undefinedLast

    if (isBoolean(aValue) && isBoolean(bValue)) {
      return order === 'asc' ? Number(aValue) - Number(bValue) : Number(bValue) - Number(aValue)
    } else if (isNumber(aValue) && isNumber(bValue)) {
      return order === 'asc' ? aValue - bValue : bValue - aValue
    } else if (isString(aValue) && isString(bValue)) {
      return order === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
    }

    return 0
  }
}
